import React, { useState, useEffect } from "react";
import TableComponent from "../../TableComponent/TableComponent";
import IconButton from "../../IconButton/IconButton";
import "./RCMManagement.css";
import { DataTableComponent } from "../../../common/TableComponent/DataTableComponent";
import { useTranslation } from "react-i18next";

const ViewRCMUserDetails = ({ onCloseViewRCMDetails, viewSlotData, slotDetails, data, onRevokeUser }) => {
    const { t, i18n } = useTranslation();
    const [tableData, setTableData] = useState([]);
    const [tableColumns, setTableColumns] = useState([])

    useEffect(() => {
        const updatedData = data?.locations?.map(item => ({
            ...item,
            country: item.countryNames.length === 0 ? '-' : item.countryNames[0],
            roleName: item.countryIds.length === 0 ? 'RCM-REGION' : 'RCM-COUNTRY'
        }));
        setTableData(updatedData);

        setTableColumns([
            { name: t("roleName"), field: "roleName", selector: row => row.roleName },
            { name: t("region"), field: "regionName", selector: row => row.regionName },
            { name: t("country"), field: "country", selector: row => row.country },
        ])
    }, [data, i18n.language]);

    return (
        <div className={["glbOuterWrapper", "slotMgmt"].join(' ')}>
            <div className="slotDetailsOuterDiv">
                <div style={{ display: 'flex' }}>
                    <div>
                        <span className="slotDetailsText">{t("email")}:</span>
                        <span className="slotName">{data?.email}</span>
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                        <span className="slotDetailsText">{t("firstName")}:</span>
                        <span className="slotName">{data?.firstName}</span>
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                        <span className="slotDetailsText">{t("lastName")}:</span>
                        <span className="slotName">{data?.lastName}</span>
                    </div>
                </div>

                <div className="buttonOuterDiv">
                    <IconButton
                        text={t("close")}
                        onClick={onCloseViewRCMDetails}
                        style={{ backgroundColor: "#F0F0F0", color: '#454647', border: '1px solid #B3B2B4' }}
                    />
                </div>
            </div>

            <div className="viewTableOuterDiv">
                <DataTableComponent
                    columns={tableColumns}
                    data={tableData}
                    tableName="viewRCM"
                    noDataMessage={t("noDataFound")}
                    onRevokeUser={onRevokeUser}
                    pageCount={5}
                />
            </div>
        </div>
    );
}

export default ViewRCMUserDetails;
